"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarContent = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const styled_tools_1 = require("styled-tools");
const Box_1 = require("./Box");
const toolbarContentTheme = styled_tools_1.theme('ToolbarContent');
exports.ToolbarContent = styled_1.default(Box_1.Box) `
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  grid-gap: inherit;
  grid-area: ${styled_tools_1.prop('align')};
  justify-content: ${styled_tools_1.prop('align')};
  align-items: center;
  [aria-orientation='vertical'] > & {
    grid-auto-flow: row;
    grid-auto-rows: min-content;
    justify-content: initial;
    align-content: ${styled_tools_1.prop('align')};
  }
  ${toolbarContentTheme};
`;
exports.ToolbarContent.defaultProps = {
    align: 'start',
};

//# sourceMappingURL=ToolbarContent.js.map
